var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 44",
    id: "Layer_44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.61,15.38l-2.83-2.83a.51.51,0,0,0-.71,0L18,31.65a.48.48,0,0,0,0,.7l19.09,19.1a.52.52,0,0,0,.71,0l2.83-2.83a.51.51,0,0,0,0-.71L24.7,32,40.61,16.09A.51.51,0,0,0,40.61,15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,3.5A28.5,28.5,0,1,0,60.5,32,28.54,28.54,0,0,0,32,3.5Zm0,52A23.5,23.5,0,1,1,55.5,32,23.52,23.52,0,0,1,32,55.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-left-icon.e32630c83f79a2e07668e93dfb9572b9.svg";
export { ForwardRef as ReactComponent };